// import ComponentOrderList from './pages/ComponentOrderList'
// import ComponentOrderForm from './pages/ComponentOrderForm'


import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
// import Dashboard from './pages/Dashboard'
// import TaskList from './pages/TaskList'
// import TaskForm from './pages/TaskForm'
// import Profile from './pages/Profile'

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes - only accessible when not logged in */}
          <Route path="/login" element={
            <ProtectedRoute requireAuth={false}>
              <Login />
            </ProtectedRoute>
          } />
          <Route path="/register" element={
            <ProtectedRoute requireAuth={false}>
              <Register />
            </ProtectedRoute>
          } />

          {/* Protected routes with Layout */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                {/* <Dashboard /> */}
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/tasks" element={
            <ProtectedRoute>
              <Layout>
                {/* <TaskList /> */}
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/tasks/new" element={
            <ProtectedRoute>
              <Layout>
                {/* <TaskForm /> */}
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/tasks/edit/:id" element={
            <ProtectedRoute>
              <Layout>
                {/* <TaskForm /> */}
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/profile" element={
            <ProtectedRoute>
              <Layout>
                {/* <Profile /> */}
              </Layout>
            </ProtectedRoute>
          } />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  )
}

export default App